import { gql } from '@apollo/client';
import { PM_ONBOARDING_SESSION_FIELDS } from './fragments.gql';

export const PM_ONBOARDING_COMPLETE_STEP = gql`
  ${PM_ONBOARDING_SESSION_FIELDS}
  mutation PmOnboardingCompleteStep($input: PmOnboardingCompleteStepInput!) {
    pmOnboardingCompleteStep(input: $input) {
      __typename
      ... on PmOnboardingSession {
        ...PmOnboardingSessionFields
      }
      ... on ValidationErrorCollection {
        errors {
          field
          message
          type
        }
      }
      ... on NotFoundError {
        message
      }
    }
  }
`;

export const PM_ONBOARDING_NAVIGATE_TO_STEP = gql`
  ${PM_ONBOARDING_SESSION_FIELDS}
  mutation PmOnboardingNavigateToStep(
    $sessionId: ID!
    $stepKey: PmOnboardingStepKey!
  ) {
    pmOnboardingNavigateToStep(sessionId: $sessionId, stepKey: $stepKey) {
      __typename
      ... on PmOnboardingSession {
        ...PmOnboardingSessionFields
      }
      ... on ValidationErrorCollection {
        errors {
          field
          message
          type
        }
      }
      ... on NotFoundError {
        message
      }
    }
  }
`;
